/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from xplatforms/schemas/document_scanner/Check.yaml
import { ScanbotCheckImpl } from './impl';
/**
 * Entry point for all Check scanning features.
 */
export const ScanbotCheck = {
    /**
     * Opens the Ready-To-Use UI Check scanner with the desired configuration.
     * @param {CheckScannerScreenConfiguration} configuration - The Check scanner configuration to be used for scanning.
     * @returns {Promise<ResultWrapper<CheckScannerUiResult>>} - The result of the Check scanning operation.
     */
    async startScanner(configuration) {
        return ScanbotCheckImpl.startScanner(configuration);
    },
    /**
     * Forces the Ready-To-Use UI Check scanner to close if it is currently open.
     * @returns {Promise<void>}
     */
    async forceCloseScanner() {
        return ScanbotCheckImpl.forceCloseScanner();
    },
    /**
     * Scans Check from a given image with the desired configuration.
     * @param {ImageInput} params.image - The image to be used for scanning.
     * @param {CheckScannerConfiguration} params.configuration - The Check scanner configuration to be used for scanning.
     * @returns {Promise<CheckScanningResult>} - The result of the Check scanning operation.
     */
    async scanFromImage(params) {
        return ScanbotCheckImpl.scanFromImage(params);
    },
};
//# sourceMappingURL=Check.js.map